module.exports = __webpack_public_path__ + "img/sentra1.6d1a5f0e.jpeg";